module.exports = __webpack_public_path__ + "img/HQ-OA-360V04NGL-T.a12d9b90.jpg";